<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><g fill="#fff"><path d="M19.558 26.339h-6.669a.89.89 0 0 1-.89-.889v-.274a6.225 6.225 0 0 1 10.27-4.733 5.979 5.979 0 0 0-2.77 5.057 6.076 6.076 0 0 0 .058.838zm-1.333-8.894a3.113 3.113 0 1 1 3.113-3.112 3.116 3.116 0 0 1-3.113 3.112z" fill="currentColor"/><path d="M24.749 29v-2.75H22v-1.5h2.749V22h1.5v2.75H29v1.5h-2.75V29z" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-step-member',
});
</script>
